// Broker Configuration
// Each broker has its own branding, colors, and settings

export const BROKER_CONFIG = {
  savexa: {
    id: 'savexa',
    name: 'Savexa',
    displayName: 'Savexa',
    logo: '/savexa-logo.svg',
    refPrefix: 'SV',
    primaryColor: '#0f172a',
    secondaryColor: '#1e40af',
    accentColor: '#3b82f6',
    gradientStart: '#0f172a',
    gradientEnd: '#1e40af',
    tagline: 'Secure Payment Solutions',
    supportEmail: 'support@savexa.com',
    supportPhone: '+92 300 1234567',
    basePath: '/savexa',
    theme: {
      headerGradient: 'linear-gradient(180deg, #0f172a 0%, #1e3a5f 50%, #1e40af 100%)',
      buttonColor: '#3b82f6',
      buttonHoverColor: '#2563eb',
      linkColor: '#3b82f6',
      badgeColor: '#dbeafe',
      badgeTextColor: '#1e40af'
    }
  },
  justmarkets: {
    id: 'justmarkets',
    name: 'JustMarkets',
    displayName: 'JustMarkets',
    logo: '/justmarkets-logo.png',
    refPrefix: 'JM',
    primaryColor: '#0f172a',
    secondaryColor: '#1e40af',
    accentColor: '#3b82f6',
    gradientStart: '#0f172a',
    gradientEnd: '#1e40af',
    tagline: 'Trade with Confidence',
    supportEmail: 'support@justmarkets.com',
    supportPhone: '+92 300 7654321',
    basePath: '/justmarkets',
    theme: {
      headerGradient: 'linear-gradient(180deg, #0f172a 0%, #1e3a5f 50%, #1e40af 100%)',
      buttonColor: '#3b82f6',
      buttonHoverColor: '#2563eb',
      linkColor: '#3b82f6',
      badgeColor: '#dbeafe',
      badgeTextColor: '#1e40af'
    }
  }
};

// Default broker (when accessing root path)
export const DEFAULT_BROKER = 'savexa';

// Get broker config by ID
export const getBrokerConfig = (brokerId) => {
  return BROKER_CONFIG[brokerId?.toLowerCase()] || BROKER_CONFIG[DEFAULT_BROKER];
};

// Get broker ID from path
export const getBrokerFromPath = (pathname) => {
  if (pathname.startsWith('/justmarkets')) {
    return 'justmarkets';
  }
  if (pathname.startsWith('/savexa')) {
    return 'savexa';
  }
  // Default to savexa for root path
  return DEFAULT_BROKER;
};

// Get all broker IDs
export const getAllBrokerIds = () => Object.keys(BROKER_CONFIG);

export default BROKER_CONFIG;
